import React from "react";
import PharmacyDashboard from "../components/pharmacy/PharmacyDashboard";
import "./Pharmacy.css";

export default function Pharmacy() {
  return (
    <div className="pharmacy-page">
      <PharmacyDashboard />
    </div>
  );
}
